<template>
  <content-page :class="$setClasses" :title="$t('inventory.title')" :loading="isLoading">
<!--    <el-card v-if="existVersion" class="--margin-bottom inventory__header">-->
<!--      <h3>{{$t('inventory.existVersion.title')}}</h3>-->
<!--      <div v-html="$t('inventory.existVersion.message')"></div>-->
<!--    </el-card>-->
<!--    <div class="inventory__button" slot="title-after">-->
<!--      <nxt-btn @click="openModal(true)"-->
<!--               type="button"-->
<!--               class="button nxt-button">-->
<!--        {{ $t('inventory.button') }}-->
<!--      </nxt-btn>-->
<!--    </div>-->
    <div
          v-if="!roomsLoading && rooms.length">
      <nxt-infos-room v-for="(room, index) in rooms"
            :room="room"
            :key="index"
            :labels="labels"
            :display-volume="false"
            :services-list="services"
            :display="!existVersion"
            :key-index="index" />
    </div>
    <p v-else-if="!roomsLoading" :class="$vClass('body__empty')">
      <el-card :class="$vClass('body__empty__card')">
        {{ $t('inventory.empty') }}
      </el-card>
    </p>
<!--    <nxt-furniture-modal :class="['furniture-modal', {'--is-mobile': isMobile}]"-->
<!--                         :rooms="rooms"-->
<!--                         :visible="displayCustomFurnitureModal"-->
<!--                         @visibilityChange="openModal(false)"-->
<!--                         @confirm="confirmInventory"-->
<!--    />-->
  </content-page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ContentPage from '@/components/layout/ContentPage.vue';

export default {
  name: 'inventory',
  nameClassStyle: 'inventory',
  components: {
    ContentPage,
  },
  data() {
    return {
      isLoading: true,
      displayCustomFurnitureModal: false,
    };
  },
  computed: {
    ...mapGetters({
      furnituresRooms: 'furnituresStore/rooms',
      isMobile: 'dimensionStore/isMobile',
      projectSelected: 'projectStore/projectSelected',
      rooms: 'inventoryStore/rooms',
      roomsLoading: 'inventoryStore/roomsLoading',
      services: 'inventoryStore/services',
    }),
    existVersion() {
      return false;
    },
    labels() {
      return {
        volume: this.$t('base.volume'),
        quantity: this.$t('base.quantity'),
        heavy: this.$t('base.heavy'),
        packaging: this.$t('base.packaging'),
        unpacking: this.$t('base.unpacking'),
      };
    },
  },
  methods: {
    ...mapActions({
      getRooms: 'inventoryStore/getRooms',
      getServices: 'inventoryStore/getServices',
      postInventory: 'inventoryStore/postInventory',
    }),
    confirmInventory() {
      // this.postInventory(this.rooms);
    },
    async init() {
      try {
        this.isLoading = true;
        await this.getRooms();
        // TODO add get services
        // await this.getServices();
        if (this.furnituresRooms && !this.furnituresRooms.length) {
          this.$store.commit('furnituresStore/SET_ROOMS', JSON.parse(JSON.stringify(this.rooms)));
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    openModal(e) {
      this.displayCustomFurnitureModal = e;
      document.body.classList[e ? 'add' : 'remove']('u-overflow-hidden');
    },
  },
  created() {
    this.init();
  },
  watch: {
    projectSelected() {
      this.init();
    },
  },
};
</script>

<style lang="scss" scoped>

.inventory {
  min-height: 600px;
  margin: 0;
  @include breakpoint(tablet) {
    margin: 0 20px;
  }
  @include breakpoint(wide) {
    margin: 0 $--wide-margin;;
  }
  @include breakpoint(wide-xl) {
    margin: 0 $--wide-xl-margin;
  }
  .--margin-bottom {
    margin-bottom: 20px;
  }
  &__header {
    h3, div {
      color: $--color-warning;
    }
  }
  &__button {
    display: flex;
    justify-content: flex-end;
    margin: 20px 0 10px 0;
    .nxt-button {
      font-size: 14px;
      background-color: transparent;
      border: $--color-primary solid 2px;
      &:hover {
        text-shadow: 1px 0 0 white;
      }
    }
    @include breakpoint(tablet) {
      margin: 0;
      .nxt-button {
        text-shadow: $--color-white;
        background-color: transparent;
        border: $--color-white solid 2px;
        color: $--color-white;
      }
    }
  }
  &__title {
    margin-top: 20px;
    margin-left: 20px;
    @include breakpoint(tablet) {
      margin-left: 0;
    }
    &--white {
      color: $--color-white;
    }
    &--white {
      color: $--color-white;
    }
  }
  &__body {
    position: relative;
    margin: 20px 0;
    &__collapse {
      border: none;
    }
    &__card {
      border-radius: 0;
      background-color: $--color-light-grey;
      @include breakpoint(tablet) {
        border-radius: 4px;
      }
    }
    &__empty {
      margin: 0;
      font-style: italic;
      &__card {
        border-radius: 0;
        @include breakpoint(tablet) {
          border-radius: 4px;
        }
      }
    }
  }
  .dialog {
    &.--is-mobile {
      height: 100%;
    }
  }
}
</style>
